module.exports = __webpack_public_path__ + "static/case_07-17c849fdb89c8b9c6b9a19541e5e4b09.jpg";